import React, { Component } from 'react';
import { css } from '@emotion/core';
import { connect } from 'react-redux';
import '../../../../styles/variables.scss';
import './TopHeaderPrimary.scss';
import LoginRegister from './LoginRegister';
import SocialMedia from './SocialMedia';
import DeliveryInfo from './DeliveryInfo';
import AssistanceInfo from './AssistanceInfo';
import Help from './Help';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';

class TopHeaderPrimary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLogin: false,
    };
  }

  // LOGIN
  toggleLogin = event => {
    event.preventDefault();

    this.setState({
      showLogin: !this.state.showLogin,
    });
  };

  closeLogin = event => {
    this.setState({
      showLogin: false,
    });
  };

  render() {
    const {
      isCheckout,
      user,
      isAuthenticated,
      onLogin,
      phone,
      phone2,
      loginError,
      primaryColor,
      secondaryColor,
      datiFarmacia,
      facebookAppId,
      hasFacebookLogin,
      shippingDescription,
      topHeaderVersion,
      freeShippingThreshold,
      headerDescription,
      headerAppLink,
      headerAppLinkIos,
      headerAppLinkAndroid,
      isMobile,
    } = this.props;

    const topHeaderStyle = css`
      &.top-header.version-1 {
        background-color: ${primaryColor};
        height: 36px;
        min-height: 36px;
        padding-left: 30px;
        padding-right: 30px;
        @media screen and (max-width: 768px) {
          padding-left: 15px;
          padding-right: 15px;
        }

        .desktop-version .container-1 {
          height: 100%;
          display: flex;
          justify-content: space-between;
          .center-top-header {
            .delivery-info-container {
              display: flex;
              @media screen and (max-width: 768px) {
                display: none;
              }
              .delivery-info {
                color: #ffff;
                & svg {
                  display: none;
                }
              }
            }
            .assistance {
              @media screen and (max-width: 992px) {
                display: none;
              }
              a {
                color: #ffff;
              }
            }
          }
        }
      }

      &.top-header.version-2,
      &.top-header.version-3 {
        width: 100%;
        height: 36px;

        .desktop-version {
          display: block;
          max-width: 94%;
        }

        .desktop-version .container-2-3 {
          display: flex;
          gap: 20px;
          justify-content: space-between;
          align-items: center;
          @media screen and (max-width: 992px) {
            align-items: center;
          }
          .center-top-header {
            margin: unset;
            div {
              display: flex;
              gap: 4px;
              .header-app-description {
                display: flex;
                flex-direction: row;
                align-items: center;
                color: #ffff;
                gap: 8px;
                @media screen and (max-width: 992px) {
                  flex-direction: column;
                  align-items: flex-start;
                }

                white-space: nowrap;
                margin-bottom: 0px;
                @media screen and (max-width: 490px) {
                  display: none;
                }
                @media screen and (max-width: 992px) {
                  flex-direction: column;
                  white-space: normal;
                  padding-left: 0px;
                }
                a {
                  color: #ffff;
                  font-weight: bold;
                  font-style: italic;
                }
              }
              .display-only-app-link {
                display: none;

                @media screen and (max-width: 490px) {
                  display: block;
                  color: #ffff;
                  font-weight: bold;
                  font-style: italic;
                }
              }
            }
            .icons-links {
              @media screen and (max-width: 400px) {
                flex-direction: column;
              }
            }
          }
          .right-top-header {
            nav .open-login.login-open .login {
              position: absolute;
              top: 212%;
              left: -218%;
              @media screen and (max-width: 370px) {
                left: -194%;
              }
            }
          }
        }
      }
    `;

    if (isMobile) {
      return null;
    }

    return (
      <div
        className={`top-header version-${topHeaderVersion} desktop`}
        style={{
          backgroundColor: primaryColor,
          order:
            topHeaderVersion === 2 ? '3' : topHeaderVersion === 3 ? '-1' : null,
        }}
        css={topHeaderStyle}
      >
        <div className="desktop-version">
          {topHeaderVersion === 1 && !isCheckout && (
            <div className="container-1">
              <div className="left-top-header">
                {!this.props.isMobile && (
                  <LoginRegister
                    user={user}
                    isAuthenticated={isAuthenticated}
                    onLogin={onLogin}
                    loginError={loginError}
                    facebookAppId={facebookAppId}
                    hasFacebookLogin={hasFacebookLogin}
                    primaryColor={primaryColor}
                  />
                )}
              </div>
              <div className="center-top-header">
                <DeliveryInfo
                  shippingDescription={shippingDescription}
                  freeShippingThreshold={freeShippingThreshold}
                  secondaryColor={secondaryColor}
                />
                <AssistanceInfo phone={phone} phone2={phone2} />
              </div>
              <div className="right-top-header">
                <SocialMedia datiFarmacia={datiFarmacia} />
                <Help />
              </div>
            </div>
          )}
          {topHeaderVersion !== 1 && !isCheckout && (
            <div className="container-2-3">
              <div className="center-top-header">
                <div>
                  <p className="header-app-description">
                    {!!headerDescription && (
                      <span
                        dangerouslySetInnerHTML={{ __html: headerDescription }}
                      />
                    )}{' '}
                    {!!headerAppLink && (
                      <a
                        className="display-only-app-link"
                        href={headerAppLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Vai
                      </a>
                    )}
                    <div style={{ display: 'flex' }}>
                      {!!headerAppLinkIos && (
                        <a
                          href={headerAppLinkIos}
                          rel="noreferrer"
                          target="_blank"
                        >
                          <ImageDispatcher
                            src="/static/images/app_store.png"
                            style={{ maxWidth: 80 }}
                            alt="Immagine Apple Store"
                          />
                        </a>
                      )}
                      {!!headerAppLinkAndroid && (
                        <a
                          href={headerAppLinkAndroid}
                          rel="noreferrer"
                          target="_blank"
                        >
                          <ImageDispatcher
                            src="/static/images/google_play.png"
                            style={{ maxWidth: 80 }}
                            alt="Immagine Google Play Store"
                          />
                        </a>
                      )}
                    </div>
                  </p>
                  <div className="icons-links" style={{ display: 'flex' }}>
                    {!!headerAppLinkIos && (
                      <a
                        className="display-only-app-link"
                        href={headerAppLinkIos}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <ImageDispatcher
                          src="/static/images/app_store.png"
                          style={{ maxWidth: 80 }}
                          alt="Immagine Apple Store"
                        />
                      </a>
                    )}
                    {!!headerAppLinkAndroid && (
                      <a
                        className="display-only-app-link"
                        href={headerAppLinkAndroid}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <ImageDispatcher
                          src="/static/images/google_play.png"
                          style={{ maxWidth: 80 }}
                          alt="Immagine Google Play Store"
                        />
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="right-top-header">
                {!this.props.isMobile && (
                  <LoginRegister
                    user={user}
                    isAuthenticated={isAuthenticated}
                    onLogin={onLogin}
                    loginError={loginError}
                    facebookAppId={facebookAppId}
                    hasFacebookLogin={hasFacebookLogin}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    hasBlog: state.store.data.features.hasBlog,
    posts: state.posts.data.latest,
    couponPageUrl: state.store.data.funzionalita.couponPageUrl,
    loginError: state.user.error,
    datiFarmacia: state.store.data.datiFarmacia,
    facebookAppId: state.store.data.integrazioni.facebook.appId,
    hasFacebookLogin: state.store.data.features.hasFacebookLogin,
  };
}

export default connect(mapStateToProps)(TopHeaderPrimary);
